import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Legacy Stripe cancel landing. New checkouts send users straight to pricing;
 * this page only handles old cancel URLs still pointing here — no popup.
 */
const CheckoutCancel: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const userType = localStorage.getItem('pendingUserType');
    localStorage.removeItem('pendingUserId');
    localStorage.removeItem('pendingUserType');

    const path = userType === 'investor' ? '/investors/pricing' : '/startups/pricing';
    navigate(path, { replace: true });
  }, [navigate]);

  return null;
};

export default CheckoutCancel;
